import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
//assistance-bookings reducers
import { reset as HistoryReset } from '_redux/slices/assistance-bookings/bookings-history';
import { reset as BookingFormReset } from '_redux/slices/assistance-bookings/booking-form';
import { reset as RequestTableReset } from '_redux/slices/assistance-bookings/booking-requests-table';
import { reset as AdditionalPassengerReset } from '_redux/slices/assistance-bookings/additional-passenger';
//bookings reducers
import { reset as TableReset } from '_redux/slices/prm-bookings/bookings-table';
import { reset as BookingsReset } from '_redux/slices/prm-bookings/bookings';
import { reset as CalendarReset } from '_redux/slices/prm-bookings/calendar';
import { reset as ArrivalsReset } from '_redux/slices/prm-bookings/arrivals';
import { reset as DeparturesReset } from '_redux/slices/prm-bookings/departures';
import { reset as BookingForecastReset } from '_redux/slices/prm-bookings/booking-forecast';
import { reset as BookingCountReset } from '_redux/slices/prm-bookings/bookings-count';
import { reset as FilterReset } from '_redux/slices/prm-bookings/filter';
import { reset as FlightBookingsReset } from '_redux/slices/prm-bookings/flights';
import { reset as SeasonalVarianceReset } from '_redux/slices/prm-bookings/seasonal-variance';
//main-screens reducers
import { reset as ScreenReset } from '_redux/slices/main-screen/render-screen';
import { reset as ModalReset } from '_redux/slices/main-screen/modal';
import { reset as ScreenLookReset } from '_redux/slices/main-screen/screen-lock';
import { logout, reset, reset as UserReset, resetStatus } from '_redux/slices/main-screen/user';
import { reset as WarningModalReset } from '_redux/slices/main-screen/warning-modal';
//analytics reducers
import { reset as ReviewsReset } from '_redux/slices/analytics/reviews';
import { reset as NewUserReset } from '_redux/slices/analytics/new-users';
import { reset as ReviewNameReset } from '_redux/slices/analytics/review-name';
import { reset as WeatherReset } from '_redux/slices/analytics/weather';
//beacons reducers
import { reset as BeaconsReset } from '_redux/slices/beacons/beacons';
//flights reducers
import { reset as FlightReset } from '_redux/slices/flights/flight-information';
//notifications reducers
import { reset as NotificationsReset } from '_redux/slices/notifications/notifications';
//prm-clubs reducers
import { reset as RewardsReset } from '_redux/slices/prm-club/rewards';
import { reset as RewardsAnalyticsReset } from '_redux/slices/prm-club/analytics';
//profile reducers
import { reset as AdminTableReset } from '_redux/slices/profile/admin-table';
import { reset as AirportInfoReset } from '_redux/slices/profile/airport-information';
import { reset as FeedbackReset } from '_redux/slices/profile/feedback';
import { reset as UserProfileReset } from '_redux/slices/profile/user-profile';
//QA reducers
import { reset as QaReset } from '_redux/slices/qa/qa';
//timeline reducers
import { reset as EmployeeReset } from '_redux/slices/timeline/employees';
import { reset as FlightScannerReset } from '_redux/slices/timeline/flight-scanner';
import { reset as SelectedTaskReset } from '_redux/slices/timeline/selected-task';
import { reset as TimelineAreaReset } from '_redux/slices/timeline/timeline-areas';
import { reset as TimelineDataReset } from '_redux/slices/timeline/timeline-data';
import { reset as resetTimeLineControl } from "_redux/slices/timeline/timeline-control";
import { reset as resetTimeLineDashboard } from "_redux/slices/timeline/timeline-dashboard";

//websites reducers
import { reset as UserBookingsReset } from '_redux/slices/website/userbookings';
import { reset as ConfirmBookingReset } from '_redux/slices/website/confirm-booking';
import { reset as ContactReset } from '_redux/slices/website/contact';
import { reset as TransactionsReset } from '_redux/slices/website/transactions';
import { reset as QrHandlerReset } from '_redux/slices/website/qr-handler';

//messages reducers
import { reset as MessagingReset } from '_redux/slices/messaging/messaging';
import { reset as resetReports } from '_redux/slices/timeline-reports/timeline-reports'

const ForceReset = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("Reset....!!")
    handleLogout()
  }, [])

  const handleLogout = () => {
    localStorage.clear();
    // logout and change page
    dispatch(logout());
    dispatch(resetReports())
    // reset all slices
    dispatch(reset());
    dispatch(resetStatus());
    dispatch(BookingFormReset());
    dispatch(RequestTableReset());
    dispatch(AdditionalPassengerReset());
    dispatch(DeparturesReset());
    dispatch(ArrivalsReset());
    dispatch(BookingForecastReset());
    dispatch(BookingCountReset());
    dispatch(FlightBookingsReset());
    dispatch(FilterReset());
    dispatch(SeasonalVarianceReset());
    dispatch(ModalReset());
    dispatch(ScreenLookReset());
    dispatch(WarningModalReset());
    dispatch(NewUserReset());
    dispatch(ReviewNameReset());
    dispatch(WeatherReset());
    dispatch(BeaconsReset());
    dispatch(FlightReset());
    dispatch(NotificationsReset());
    dispatch(RewardsAnalyticsReset());
    dispatch(AdminTableReset());
    dispatch(AirportInfoReset());
    dispatch(FeedbackReset());
    dispatch(UserProfileReset());
    dispatch(QaReset());
    dispatch(EmployeeReset());
    dispatch(FlightScannerReset());
    dispatch(SelectedTaskReset());
    dispatch(TimelineAreaReset());
    dispatch(TimelineDataReset());
    dispatch(resetTimeLineControl());
    dispatch(resetTimeLineDashboard());
    dispatch(ConfirmBookingReset());
    dispatch(ContactReset());
    dispatch(TransactionsReset());
    dispatch(QrHandlerReset());
    dispatch(UserReset())
    dispatch(HistoryReset())
    dispatch(TableReset())
    dispatch(BookingsReset())
    dispatch(CalendarReset())
    dispatch(ScreenReset())
    dispatch(ReviewsReset())
    dispatch(RewardsReset())
    dispatch(UserBookingsReset())
    dispatch(MessagingReset())
  }
  return (
    <div>

    </div>
  )
}

export default ForceReset
